export const URL = "http";

const Constants = {
    auth0: {
        //baseUrl: "http://sdn-api.aluserver.com"
        baseUrl: "https://alucardri.auth0.com"
    },
    auth: {
        baseUrl: process.env.VUE_APP_AUTH_API
        // baseUrl: "http://accesscontrol-api.aluserver.com/access"
        // baseUrl: "http://localhost:61379/access"
    },
    sdn: {
        baseUrl: process.env.VUE_APP_SDN_API
        // baseUrl: "http://sdn-hml-api.aluserver.com"
        //baseUrl: "http://localhost:4759"
    }
}

export default Constants;